import { createAsyncThunk } from "@reduxjs/toolkit";
import { logoutUser } from "./authThunks";

const API_BASE = process.env.REACT_APP_API_BASE;

/**
 * fetch all Vendor entries
 */
export const fetchVendorItems = createAsyncThunk(
  "vendor/fetchItems",
  async (_, thunkAPI) => {
    const res = await fetch(`${API_BASE}/api/vendor`, {
      method: "GET",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
        "x-user-role": "vendor",
      },
    });
    if (res.status === 401) {
      thunkAPI.dispatch(logoutUser());
      window.location.href = process.env.REACT_APP_AUTH_BASE_URL;
      return thunkAPI.rejectWithValue("Unauthorized");
    }
    const json = await res.json();
    if (!res) {
      throw new Error(json?.message || "Fetch failed");
    }
    return json;
  }
);

export const fetchVendorById = createAsyncThunk(
  "vendor/fetchById",
  async (vendorId, thunkAPI) => {
    const res = await fetch(
      `${API_BASE}/api/vendor/getByParam/?account_id=${vendorId}`,
      {
        method: "GET",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          "x-user-role": "vendor",
        },
      }
    );
    if (res.status === 401) {
      thunkAPI.dispatch(logoutUser());
      window.location.href = process.env.REACT_APP_AUTH_BASE_URL;
      return thunkAPI.rejectWithValue("Unauthorized");
    }

    const json = await res.json();
    if (!res.ok) {
      throw new Error(json?.message || "Failed to fetch vendor by ID");
    }

    return json;
  }
);

export const fetchVendorByEmail = createAsyncThunk(
  "vendor/fetchById",
  async (email, thunkAPI) => {
    const res = await fetch(
      `${API_BASE}/api/vendor/getByParam/?vendor_work_email=${email}`,
      {
        method: "GET",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          "x-user-role": "vendor",
        },
      }
    );
    if (res.status === 401) {
      thunkAPI.dispatch(logoutUser());
      window.location.href = process.env.REACT_APP_AUTH_BASE_URL;
      return thunkAPI.rejectWithValue("Unauthorized");
    }
    const json = await res.json();
    if (!res.ok) {
      throw new Error(json?.message || "Failed to fetch vendor by ID");
    }

    return json;
  }
);

export const uploadImage = createAsyncThunk(
  "vendorsonhome/uploadImage",
  async (data) => {
    const formData = new FormData();
    formData.append("file", data);
    const res = await fetch(`${API_BASE}/api/upload`, {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json",
        "x-user-role": "vendor",
      },
      body: formData,
    });

    const json = await res.json();
    if (!res) {
      throw new Error(json?.message || "Fetch failed");
    }
    return json;
  }
);

export const updateVendorsonhome = createAsyncThunk(
  "vendor/updateItems",
  async (data, thunkAPI) => {
    try {
      const body = JSON.stringify(data);

      const res = await fetch(`${API_BASE}/api/vendor`, {
        method: "PUT",
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
          "x-user-role": "vendor",
        },
        body: body,
      });

      if (res.status === 401) {
        thunkAPI.dispatch(logoutUser());
        window.location.href = process.env.REACT_APP_AUTH_BASE_URL;
        return thunkAPI.rejectWithValue("Unauthorized");
      }

      if (res.status === 403) {
        return thunkAPI.rejectWithValue(
          "Access denied: insufficient permissions"
        );
      }

      const json = await res.json();
      if (!res.ok) {
        return thunkAPI.rejectWithValue(json?.message || "Fetch failed");
      }

      return json;
    } catch (error) {
      return thunkAPI.rejectWithValue(error.message || "Network error");
    }
  }
);

